import React from "react";
import "./Styles.css";

const ProjectCard = ({ loading, posts }) => {
  if (loading) {
    return <h2>Loading...</h2>;
  }

  return (
    <div class="container" style={{ width: "100%" }}>
      {posts.map((p, i) => {
        return (
          <div className="card-body" style={{ display: "block" }}>
            <div className="content-img">
              <img src={p.image} alt={p.title} />
            </div>
            <div className="card-text">
              <p class="tag">
                {p.tags.map((text, i) => {
                  return (
                    <p className="tagText" key={i}>
                      {text}
                    </p>
                  );
                })}
              </p>
              <div style={{ display: "flex" }}>
                <h2>
                  {p.title} <sub className="subs">{p.subDescription}</sub>
                </h2>
              </div>
              <p
                className="text"
                style={{ minHeight: "60px", maxHeight: "70px" }}
              >
                {p.description}
              </p>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-around",
                  paddingBottom: "10px",
                }}
              >
                {p.visit !== "" ? (
                  <a href={p.visit} target="_blank" class="read-more">
                    Live Demo
                  </a>
                ) : null}
                {p.source !== "" ? (
                  <a href={p.source} target="_blank" class="read-more">
                    Source Code
                  </a>
                ) : null}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ProjectCard;
